<template>
  <div>
    <div v-if="loading">
      <loader></loader>
    </div>
    <b-card>
      <div slot="header">
        <strong>Registro de Accesos</strong>
      </div>
      <b-card-body>
        <form @submit.prevent="generarInforme()" data-vv-scope="formulario">
          <b-row style="justify-content: center">
            <b-col sm="4">
              <b-form-group label="Empresa" horizontal="">
                <el-select
                  name="empresa"
                  id="empresa"
                  v-model="selectedEmpresa.id"
                  filterable
                  remote
                  clearable
                  data-vv-as=" "
                  v-validate="'required'"
                  no-data-text="No hay datos que coincidan"
                  no-match-text="No hay datos que coincidan"
                  :remote-method="buscarEmpresa"
                >
                  <el-option
                    v-for="empresa in empresas.data"
                    :key="empresa.id"
                    :label="empresa.nombre"
                    :value="empresa.id"
                  >
                  </el-option>
                </el-select>
              </b-form-group>
              <span
                v-if="errors.first('formulario.empresa')"
                style="color: red"
              >
                * La empresa es obligatoria
              </span>
            </b-col>
          </b-row>
          <b-row class="d-flex justify-content-center">
            <b-col lg="4">
              <b-form-group label="Fecha" horizontal>
                <el-date-picker
                  v-model="filtrosBusqueda.fecha"
                  type="daterange"
                  name="fecha"
                  id="fecha"
                  class="w-100"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  range-separator="a"
                  start-placeholder="Fecha inicio"
                  end-placeholder="Fecha fin"
                  :picker-options="pickerOptions"
                  v-validate="'required'"
                  data-vv-as=" "
                />
              </b-form-group>
              <span v-if="errors.first('formulario.fecha')" style="color: red">
                * Este campo es obligatorio
                <br /><br />
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex justify-content-center">
              <b-button :disabled="currentCompany.aplica_control_accesos == 0" variant="info" @click="mostrarInformesAgendados(true)">
                Consultar informes
              </b-button>
              <b-button :disabled="currentCompany.aplica_control_accesos == 0"
                variant="primary"
                @click="generarInforme()"
                class="ml-2"
              >
                Generar informe
              </b-button>
            </b-col>
          </b-row>
          <b-modal
            class="modalInformesMasivo"
            hide-footer
            v-model="modalInformes"
            size="xl"
            :title="'Informes agendados'"
          >
            <informesAgendados
              :informes="informesProcesados"
            ></informesAgendados>
          </b-modal>
        </form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { getAcls } from "../../../plugins/acl";
import loader from "../../../containers/loader";
import Treeselect from "@riophae/vue-treeselect";
import informesAgendados from "./informesAgendados";

import Vue from "vue";

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";

Vue.use(VeeValidate, {
  fieldsBagName: "vvFields",
  events: "change",
});

Validator.localize("es", es);

export default {
  name: "registros-accesos-main",
  data: function () {
    return {
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          const oneYearAgo = new Date().setFullYear(today.getFullYear() - 1);
          return time.getTime() > today.getTime() || time.getTime() < oneYearAgo;
        },
      },
      esAdmin: false,
      esEmpresa: false,
      esEmpresaContratista: false,
      rol: "",
      permisos: [],
      max: "",
      min: "",
      loading: false,
      listaEmpresas: [],
      acls: "",
      modalInformes: false,
      currentCompany: {
        aplica_control_accesos: 0
      }
          };
  },
  components: {
    loader,
    Treeselect,
    informesAgendados,
  },
  async created() {
    this.load(false);
    await this.clearFilterAccess();
    const date = new Date();
    const monthmax = (date.getMonth() + 1).toString().padStart(2, "0");
    const monthmin = (date.getMonth() - 2).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    this.max = date.getFullYear() + "-" + monthmax + "-" + day;
    this.min = date.getFullYear() + "-" + monthmin + "-" + day;
  },
  methods: {
    ...mapMutations("registrosAccesos", ["clearFilterAccess"]),
    async mostrarInformesAgendados(boolean) {
      this.load(true);
      await this.listarInformesAgendados();
      this.load(false);
      if (boolean === true) {
        this.modalInformes = true;
      }
    },
    async buscarEmpresa(query) {
      if (query.length >= 3) {
        await this.getEmpresaFiltro(query);
      } else {
        this.listaEmpresas = [];
      }
    },
    async generarInforme() {
      this.$validator.validateAll("formulario").then(async (result) => {
        if (result) {
          this.load(true);
          let formData = {
            fecha: this.filtrosBusqueda.fecha,
            empresa: this.selectedEmpresa.id,
          };
          await this.agendarInforme(formData);
          await this.mostrarInformesAgendados(true);
          this.load(false);
        }
      });
    },
    ...mapActions("registrosAccesos", [
      "agendarInforme",
      "listarInformesAgendados",
    ]),
    ...mapActions("empresa", ["getEmpresaFiltro"]),
    ...mapMutations("dashboard", ["load"]),

  },
  computed: {
    ...mapState("registrosAccesos", [
      "selectedEmpresa",
      "filtrosBusqueda",
      "informesProcesados",
      "filtrosBusqueda",
    ]),
    ...mapState("empresa", ["empresas"])
  },
  watch: {
    'selectedEmpresa.id' : function (val) {
      if (this.empresas && this.empresas.data && this.empresas.data.length && val) {
        this.currentCompany = this.empresas.data.find(item => item.id == val)
      } else {
        this.currentCompany = { aplica_control_accesos: 0}
      }
    }
  }
};
</script>
<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>
<style scoped>
@media (min-width: 576px) and (max-width: 991px) {
  .modalAdjuntosMasivo {
    max-width: 90%;
  }
}
</style>

